import options from './live-motion-card.component';

export default {
    selector: 'dtLiveMotionCard',
    options
};
